export enum DialogMessagesEnum {
  DeletingPresetHeader = 'Deleting preset',
  DeleteWallConfirmationHeader = 'Are you sure you want to delete this wall?',
  DeleteWallConfirmationMessage = 'This action will remove your screens from current wall',
  ApplyConfirmationHeader = 'Are you sure?',
  ApplyConfirmationMessage = 'This action will replace your settings',
  ApplyingPresetHeader = 'Applying preset',
  ApplyVideoWallConfirmationMessage = 'Would you like to apply the new changes made in the video wall\'s layout?',
  RestartSpacedeskConfirmationMessage = 'This action will restart spacedesk on all selected devices',
  UpdateSpacedeskConfirmationMessage = 'This action will update spacedesk on all selected devices',
  RestartAndroidConfirmationMessage = 'This action will restart Android on all selected devices',
  RelaunchClientConfirmationMessage = 'This will clear all the running playlists on the screens.'
}
